module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/15.8d6ff0b7.jpg";